/**
 * Iter-129 — Canonical character ordering.
 *
 * Pilot requirement: cast ordering must be natural-numeric on the
 * `character_number` field, with characters that have no number sorted
 * by name (case-insensitive) at the end.
 *
 *   Correct:  1 Felix · 2 Donny · 3 Marina · 10 X · 11 Y · 12 Z
 *   Wrong:    10 · 11 · 12 · 2 · 3 (string sort)
 */

const numericPart = (s) => {
    const m = String(s ?? "").match(/^(\d+)/);
    return m ? parseInt(m[1], 10) : null;
};

export function compareCharacters(a, b) {
    const an = numericPart(a?.character_number);
    const bn = numericPart(b?.character_number);
    if (an != null && bn != null) {
        if (an !== bn) return an - bn;
        // Same numeric prefix — fall back to suffix string compare
        return String(a?.character_number || "").localeCompare(
            String(b?.character_number || ""),
        );
    }
    if (an != null) return -1; // numbered first
    if (bn != null) return 1;
    // Neither has a number — alphabetical by name.
    return String(a?.name || "")
        .toLowerCase()
        .localeCompare(String(b?.name || "").toLowerCase());
}

export function sortCharacters(chars) {
    return [...(chars || [])].sort(compareCharacters);
}
